<template lang="">
  <div class="all">
    <div v-if="language == 'en'" class="extendedRichtext">
      <h1>Cookie List</h1>
      <div>
        <div class="text">
          <p>
            A cookie is a small piece of data (text file) that a website – when
            visited by a user – asks your browser to store on your device in
            order to remember information about you, such as your language
            preference or login information. Those cookies are set by us and
            called first-party cookies. We also use third-party cookies – which
            are cookies from a domain different than the domain of the website
            you are visiting – for our advertising and marketing efforts. More
            specifically, we use cookies and other tracking technologies for the
            following purposes:
          </p>
        </div>
        <div class="text"><h3>Strictly Necessary Cookies</h3></div>
        <div class="text">
          <p>
            These cookies are necessary for the website to function and cannot
            be switched off in our systems. They may be set in response to
            actions made by you which amount to a request for services, such as
            setting your privacy preferences, logging in, or filling out forms.
            You can set your browser to block or alert you about these cookies,
            but some parts of the site may not then work.
          </p>
        </div>
        <div class="cookieform">
          <div class="cookietop">
            <div class="cookietopitem">Cookie Subgroup</div>
            <div class="cookietopitem">Cookies</div>
            <div class="cookietopitem">Cookies used</div>
            <div class="cookietopitem">Lifespan</div>
          </div>
          <div class="cookiebottom">
            <div class="cookiebottomitem">aliyunportal.henkel.cn</div>
            <div class="cookiebottomitem">JSESSIONID, token</div>
            <div class="cookiebottomitem">First Party</div>
            <div class="cookiebottomitem">Session,Session</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="language == 'cn'" class="extendedRichtext">
      <h1>Cookie 列表</h1>
      <div>
        <div class="text">
          <p>
            Cookie 是少量数据（文本文件），当用户访问网站时，网站要求浏览器将
            Cookie
            存储在您的设备中以记住关于您的信息，如语言偏好或登录信息。这类
            Cookie 由我们设定，称为第一方 Cookie。更具体地说，我们使用 Cookie
            和其他跟踪技术用于以下目的：
          </p>
        </div>
        <div class="text"><h3>绝对必要的 Cookie</h3></div>
        <div class="text">
          <p>
            网站运行离不开这些 Cookie
            且您不能在系统中将其关闭。通常仅根据您所做出的操作（即服务请求）来设置这些
            Cookie，如设置隐私偏好、登录或填充表格。您可以将您的浏览器设置为阻止或向您提示这些
            Cookie，但可能会导致某些网站功能无法工作。
          </p>
        </div>
        <div class="cookieform">
          <div class="cookietop">
            <div class="cookietopitem">Cookie 子群</div>
            <div class="cookietopitem">Cookie</div>
            <div class="cookietopitem">Cookie 已使用</div>
            <div class="cookietopitem">使用期限</div>
          </div>
          <div class="cookiebottom">
            <div class="cookiebottomitem">aliyunportal.henkel.cn</div>
            <div class="cookiebottomitem">
              sidebarStatus, JSESSIONID, language, token
            </div>
            <div class="cookiebottomitem">First Party</div>
            <div class="cookiebottomitem">会话,会话,会话,会话</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { uiHelper } from "@/core/utils";

export default {
  name: "Imprint",
  data: () => ({}),
  computed: {
    language() {
      return uiHelper.getLocalStorage("language");
    },
  },
};
</script>
<style lang="scss">
.all {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 60px;
  font-size: 10px;
  color: #000;
  font-family: Segoe UI, Helvetica, sans-serif;
  position: relative;
  min-height: 100%;
  .standard-content .text > p:not(.h1-like-headline) {
    margin: 0 0 1.5em;
    max-width: 829px;
  }

  .extendedRichtext {
    width: 70%;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    line-height: 1.428571429;
    font-size: 10px;
    color: #000;
    font-family: Segoe UI, Helvetica, sans-serif;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    h1 {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      box-sizing: border-box;
      font-family: inherit;
      line-height: 1.3;
      margin: 0;
      color: #e1000f;
      float: left;
      padding: 0 0 0.75em;
      width: 100%;
      word-wrap: break-word;
      max-width: 100%;
      font-weight: 300;
      font-size: 6rem;
    }
    h2 {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      font-family: inherit;
      line-height: 1.3;
      color: inherit;
      font-weight: 400;
      max-width: 829px;
      font-size: 2.4rem;
      margin-top: 0;
      margin-bottom: 0.65em;
    }
    h3 {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      font-family: inherit;
      line-height: 1.3;
      font-weight: 400;
      color: #e1000f;
      margin-top: 0;
      max-width: 829px;
      font-size: 2.4rem;
      margin-bottom: 0.5em;
    }
    p {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      line-height: 1.428571429;
      color: #000;
      font-family: Segoe UI, Helvetica, sans-serif;
      box-sizing: border-box;
      padding: 0;
      font-size: 1.6rem;
      margin: 0 0 1.5em !important;
    }
    .fixed-footer {
      position: absolute;
      bottom: 0px;
      right: 0px;
      width: 100%;
      height: 80px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    .cookieform {
      width: 100%;
      height: auto;
      border: 1px solid #d7d7d7;
      border-radius: 3px;
      overflow: hidden;
      margin-bottom: 100px;
    }
    .cookietop {
      width: 100%;
      display: flex;
      justify-content: center;
      height: 48px;
      background: #cccccc;
    }
    .cookietopitem {
      width: 25%;
      font-size: 16px;
      color: #000;
      font-family: Segoe UI, Helvetica, sans-serif;
      box-sizing: border-box;
      padding: 12px;
      border-right: 1px solid #d7d7d7;
      border-bottom: 1px solid #d7d7d7;
    }
    .cookietopitem:last-child {
      border-right: none;
    }
    .cookiebottom {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    .cookiebottomitem {
      width: 25%;
      font-size: 14px;
      color: #000;
      font-family: Segoe UI, Helvetica, sans-serif;
      box-sizing: border-box;
      padding: 12px;
      border-right: 1px solid #d7d7d7;
    }
    .cookiebottomitem:last-child {
      border-right: none;
    }
  }
}
</style>
